import { Skeleton } from '@gravity-ui/uikit';

import styles from '../styles.module.scss';

export const Loader = () => {
	return (
		<div className={styles.profile__container}>
			<Skeleton className={styles.profile__img} />
			<div className={styles.profile__form}>
				<form>
					<div className={styles.profile__inputs}>
						<div className={styles.profile__inputs__row}>
							<Skeleton style={{ width: '187px', height: '44px' }} />
							<Skeleton style={{ width: '585px', height: '44px' }} />
						</div>
						<div className={styles.profile__inputs__row}>
							<Skeleton style={{ width: '187px', height: '44px' }} />
							<Skeleton style={{ width: '585px', height: '44px' }} />
						</div>
						<div className={styles.profile__inputs__row}>
							<Skeleton style={{ width: '187px', height: '44px' }} />
							<Skeleton style={{ width: '585px', height: '44px' }} />
						</div>
						<div className={styles.profile__inputs__row}>
							<Skeleton style={{ width: '187px', height: '44px' }} />
							<Skeleton style={{ width: '585px', height: '44px' }} />
						</div>
						<div className={styles.profile__inputs__row}>
							<Skeleton style={{ width: '187px', height: '44px' }} />
							<Skeleton style={{ width: '585px', height: '44px' }} />
						</div>
						<div className={styles.profile__inputs__row}>
							<Skeleton style={{ width: '187px', height: '44px' }} />
							<Skeleton style={{ width: '585px', height: '44px' }} />
						</div>
						<div className={styles.profile__inputs__row}>
							<Skeleton style={{ width: '187px', height: '44px' }} />
							<Skeleton style={{ width: '585px', height: '108px' }} />
						</div>
					</div>
					<Skeleton style={{ width: '787px', height: '20px' }} />
					<Skeleton style={{ width: '787px', height: '20px' }} />
					<Skeleton style={{ width: '152px', height: '44px', alignSelf: 'end' }} />
				</form>
			</div>
		</div>
	);
};
